import { render, staticRenderFns } from "./ImgSwiper.vue?vue&type=template&id=0ed6f6b0&scoped=true&"
import script from "./ImgSwiper.vue?vue&type=script&lang=js&"
export * from "./ImgSwiper.vue?vue&type=script&lang=js&"
import style0 from "./ImgSwiper.vue?vue&type=style&index=0&id=0ed6f6b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed6f6b0",
  null
  
)

component.options.__file = "ImgSwiper.vue"
export default component.exports